// https://vuex.vuejs.org/kr/guide/mutations.html#%EB%B3%80%EC%9D%B4
import { MutationTree } from 'vuex'
import * as types from './types'

export default <MutationTree<RootState>>{}
